import gql from 'graphql-tag';

export const GET_ACCOUNT_SETTINGS_INFO = gql`
  query getAccountSettingsInfo($accountId: Int!) {
    account(id: $accountId) {
      id
      name
      customerType
      paymentMethods {
        id
      }
      utilityCredentials {
        id
        verificationStatus
      }
      utilityAccounts {
        id
        targetBillExperience
        funnelBillExperience
        activeBillingSettings {
          billExperience
        }
      }
      user {
        originationSource {
          funnel
        }
      }
    }
  }
`;

export const getAccountSettingsInfoMock = {
  account: {
    __typename: 'Account',
    id: 2,
    name: 'Account 1',
    customerType: undefined,
    paymentMethods: [{ id: 1 }, { id: 2 }],
    utilityCredentials: [{ id: 11, verificationStatus: 'correct' }],
    utilityAccounts: [
      {
        id: 21,
        targetBillExperience: 'utility_billed',
        funnelBillExperience: null,
        activeBillingSettings: [{ billExperience: 'utility_billed' }],
      },
      {
        id: 22,
        targetBillExperience: 'arcadia_billed',
        funnelBillExperience: 'arcadia_billed',
        activeBillingSettings: [{ billExperience: null }],
      },
    ],
    user: {
      originationSource: {
        funnel: 'goSolar',
      },
    },
  },
};
